import IdeRunner from "../../lms-shared/IdeRunnerWarrper/IdeRunner"
import { postsApi } from '../../../utils'
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import classes from './ProjectViewer.module.css'
import Header from "../../Header/Header";
import { applicationActions } from "../../../store/application-slice";
import ConfirmShareProjectPopup from "../Dashboard/Friends/Share/ConfirmShareProjectPopup";
import { ObjectTypeEnumText } from "../../../models/ObjectTypeEnum";
import { onKeyDown } from "../../../service";
import SelectStudyGroupPopup from "./SelectStudyGroupPopup";

const ProjectViewer = () => {
    const dispatch = useDispatch();
    const { applictionName, postId, studyGroupId } = useParams();
    const [projectData, setProjectData] = useState()
    const baseDispatch = useDispatch()
    const { texts, lang } = useSelector(state => state.translate);
    const { curriculums } = useSelector(state => state.curriculums);
    const uiData = useSelector((state) => state.general.uiData);
    const [showPopup, setShowPopup] = useState()
    const [localStudyGroupId, setLocalStudyGroupId] = useState(null)
    const [showSelectStudyGroup, setShowSelectStudyGroup] = useState(null)

    useEffect(() => {
        if (uiData)
            dispatch(applicationActions.setInitial({ applictionName, uiData }))
    }, [dispatch, uiData])

    const handleCopyProject = () => {
        if (studyGroupId || localStudyGroupId) {
            let data = {
                id: postId,
                refObjectType: ObjectTypeEnumText.StudyGroup,
                refObjectId: studyGroupId || localStudyGroupId
            }
            postsApi.postsImportRefObjectPost({ postImportRefObjectInput: data }, (error, resdata, response) => {
                if (error) {
                    baseDispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "postsImportRefObjectPost " + error.message, level: 1, component: "Project", line: 39 }))
                }
                else {
                    setLocalStudyGroupId(null);
                    setShowSelectStudyGroup(null);
                    const courseName = curriculums?.find(c => c.id === studyGroupId || localStudyGroupId)?.name;
                    const text = `${texts.theProject} "${projectData?.assessmentName}" ${texts.availableInSandBox}\n ${courseName} > ${texts.projects} > ${texts.DraftScreen}`;
                    setShowPopup(<ConfirmShareProjectPopup title={texts["copyToMyProjects"]} close={() => setShowPopup(false)} text={text} type={"successUpdatePost"} />)
                }
            })
        }
        else {
            setShowSelectStudyGroup(true)
        }
    }

    useEffect(() => {
        if (lang) {
            postsApi.postsFilterIdPost(postId, (error, resdata, response) => {
                if (error) {
                    baseDispatch(throwApiError({ userMessage: texts.projectsFilterIdError, error: error, statusCode: response?.statusCode, message: "projectsFilterPost " + error.message, level: 2, component: "Project", line: 58 }))
                } else {
                    if (resdata) {

                        let ide = JSON.parse(resdata.contentData)
                        setProjectData({
                            assessmentName: resdata.name,
                            ideUrl: ide.Ide.Url,
                            ideId: ide.Ide.Id,
                            ideLang: ide.Ide.Lang ? ide.Ide.Lang : lang,
                            ideConfig: JSON.parse(ide.Ide.AdditionalConfiguration),
                            fileUrl: resdata.url,
                            share: false,
                            author: `${resdata.user?.firstName} ${resdata.user?.lastName}`,
                        })
                    }
                }
            })
        }
    }, [lang])

    return (
        <div>
            <Header>
                <div className={classes.Container}>
                    <div className={classes.Text}>{texts.author} {projectData?.author}</div>
                    <div className={classes.AssessmentImg}></div>
                    <div className={classes.Text}>
                        <div className={classes.InnerText}>{projectData?.assessmentName}</div>
                    </div>
                    <div className={classes.CopyCodeContainer} onClick={() => handleCopyProject()} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleCopyProject())}>
                        <div className={classes.CopyText}>{texts.copyToMyProjects}</div>
                        <div className={classes.CopyIcon}></div>
                    </div>
                </div>
            </Header>
            <div className={classes.IdeRunnerWarrper}>
                {projectData && <IdeRunner projectData={projectData}> </IdeRunner>}
            </div>
            {showPopup}
            {showSelectStudyGroup && <SelectStudyGroupPopup localStudyGroupId={localStudyGroupId} setLocalStudyGroupId={setLocalStudyGroupId} setShowSelectStudyGroup={setShowSelectStudyGroup} handleCopyProject={handleCopyProject} />}
        </div>
    )
}
export default ProjectViewer